import { SvgTypesProps } from '@/shared/types/SvgTypes';
import styled from './IconSettings.module.scss';
import classNames from 'classnames';
export function IconSettings({
  fill = 'var(--unique-white-10)',
  width = 4,
  height = 14,
  isHover = true
}: SvgTypesProps & { isHover?: boolean }) {
  return (
    <svg width={width} height={height} viewBox="0 0 4 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={classNames(isHover ? styled.iconSettings : '')} >
      <path d="M2 10.5C2.82843 10.5 3.5 11.1716 3.5 12C3.5 12.8284 2.82843 13.5 2 13.5C1.17157 13.5 0.5 12.8284 0.5 12C0.5 11.1716 1.17157 10.5 2 10.5Z" fill={fill}/>
      <path d="M2 5.5C2.82843 5.5 3.5 6.17157 3.5 7C3.5 7.82843 2.82843 8.5 2 8.5C1.17157 8.5 0.5 7.82843 0.5 7C0.5 6.17157 1.17157 5.5 2 5.5Z" fill={fill}/>
      <path d="M2 0.5C2.82843 0.5 3.5 1.17157 3.5 2C3.5 2.82843 2.82843 3.5 2 3.5C1.17157 3.5 0.5 2.82843 0.5 2C0.5 1.17157 1.17157 0.5 2 0.5Z" fill={fill}/>
    </svg>
  );
}
